/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationGroupType } from './OrganizationGroupType';
import {
    OrganizationGroupTypeFromJSON,
    OrganizationGroupTypeFromJSONTyped,
    OrganizationGroupTypeToJSON,
    OrganizationGroupTypeToJSONTyped,
} from './OrganizationGroupType';

/**
 * 
 * @export
 * @interface OrganizationResponse
 */
export interface OrganizationResponse {
    /**
     * 
     * @type {any}
     * @memberof OrganizationResponse
     */
    organizationId?: any | null;
    /**
     * 
     * @type {OrganizationGroupType}
     * @memberof OrganizationResponse
     */
    organizationGroupType?: OrganizationGroupType;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    note?: string | null;
}



/**
 * Check if a given object implements the OrganizationResponse interface.
 */
export function instanceOfOrganizationResponse(value: object): value is OrganizationResponse {
    return true;
}

export function OrganizationResponseFromJSON(json: any): OrganizationResponse {
    return OrganizationResponseFromJSONTyped(json, false);
}

export function OrganizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'organizationGroupType': json['organizationGroupType'] == null ? undefined : OrganizationGroupTypeFromJSON(json['organizationGroupType']),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'code': json['code'] === undefined ? undefined : json['code'] === null ? null : json['code'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
    };
}

export function OrganizationResponseToJSON(json: any): OrganizationResponse {
    return OrganizationResponseToJSONTyped(json, false);
}

export function OrganizationResponseToJSONTyped(value?: OrganizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'organizationGroupType': OrganizationGroupTypeToJSON(value['organizationGroupType']),
        'isActive': value['isActive'],
        'code': value['code'],
        'name': value['name'],
        'note': value['note'],
    };
}

